module.exports = __webpack_public_path__ + "img/mobile-37.9e2e47a0.png";